module.exports = __webpack_public_path__ + "img/card_background.3f8cf4ea.png";